import CoulombLogo from "../../Assets/Icons/CoulombLogo.svg";
import jbmLogo from "../../Assets/Images/Sidebar/jbmLogo.png";

const logoMap = {
  // prod instances
  "jbmecobolt.jbmgroup.com": jbmLogo,
  "jbm.coulomb.ai": jbmLogo,

  // dev instances
  // "bessindia.coulomb.ai": jbmLogo,
};

export const getLogoForDomain = (domain) => {
  return logoMap[domain] || CoulombLogo; // return null if no logo found
};
